import { Link } from "react-router-dom";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="border-t bg-muted/20">
      <div className="container mx-auto px-6 py-12">
        {/* Tagline Strip */}
        <div className="text-center pb-8 mb-8 border-b border-border/50">
          <p className="text-muted-foreground text-sm md:text-base">
            Strategic growth systems and AI-native tools for founders, CMOs, and revenue leaders.
          </p>
        </div>

        {/* 4-Column Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Column 1: The Systems */}
          <nav aria-label="Systems navigation">
            <h3 className="font-semibold text-foreground mb-4 text-sm uppercase tracking-wide">
              The Systems
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/ai-systems" className="text-muted-foreground hover:text-foreground transition-colors">
                  AI Growth Stack
                </Link>
              </li>
              <li>
                <Link to="/framework" className="text-muted-foreground hover:text-foreground transition-colors">
                  Framework
                </Link>
              </li>
              <li>
                <Link to="/ai-systems/friction-audit" className="text-muted-foreground hover:text-foreground transition-colors">
                  Friction Audit
                </Link>
              </li>
              <li>
                <Link to="/ai-systems/roi-calculator" className="text-muted-foreground hover:text-foreground transition-colors">
                  ROI Calculator
                </Link>
              </li>
            </ul>
          </nav>

          {/* Column 2: The Models */}
          <nav aria-label="Models navigation">
            <h3 className="font-semibold text-foreground mb-4 text-sm uppercase tracking-wide">
              The Models
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/decay-model" className="text-muted-foreground hover:text-foreground transition-colors">
                  MAD-M Decay Model
                </Link>
              </li>
              <li>
                <Link to="/mahi-index" className="text-muted-foreground hover:text-foreground transition-colors">
                  MAHI™ Index
                </Link>
              </li>
              <li>
                <Link to="/research" className="text-muted-foreground hover:text-foreground transition-colors">
                  Research & White Papers
                </Link>
              </li>
              <li>
                <a href="https://marketdisruptorsagency.com/mahi-100" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">
                  MAHI-100 Protocol
                </a>
              </li>
              <li>
                <a href="https://marketdisruptorsagency.com/ai-discovery" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">
                  Market Disruptors AI Discovery
                </a>
              </li>
            </ul>
          </nav>

          {/* Column 3: The Proof */}
          <nav aria-label="Proof navigation">
            <h3 className="font-semibold text-foreground mb-4 text-sm uppercase tracking-wide">
              The Proof
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/case-studies" className="text-muted-foreground hover:text-foreground transition-colors">
                  Case Studies
                </Link>
              </li>
              <li>
                <Link to="/about/insights" className="text-muted-foreground hover:text-foreground transition-colors">
                  Insights
                </Link>
              </li>
              <li>
                <Link to="/glossary" className="text-muted-foreground hover:text-foreground transition-colors">
                  AI Marketing Glossary
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors">
                  About
                </Link>
              </li>
              <li>
                <a href="https://marketdisruptorsagency.com/about/kristina" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">
                  Market Disruptors Founder Profile
                </a>
              </li>
              <li>
                <a href="https://marketdisruptorsagency.com/press" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">
                  Market Disruptors Press & Research
                </a>
              </li>
            </ul>
          </nav>

          {/* Column 4: Ops & Contact */}
          <nav aria-label="Operations navigation">
            <h3 className="font-semibold text-foreground mb-4 text-sm uppercase tracking-wide">
              Ops & Contact
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/speaking" className="text-muted-foreground hover:text-foreground transition-colors">
                  Speaking & Media
                </Link>
              </li>
              <li>
                <Link to="/press" className="text-muted-foreground hover:text-foreground transition-colors">
                  Press Kit
                </Link>
              </li>
              <li>
                <Link to="/engagement-protocol" className="text-muted-foreground hover:text-foreground transition-colors">
                  The Engagement Protocol
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors">
                  Terms of Use
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* AI Usage Disclaimer */}
        <div className="text-center pt-8 border-t border-border/50 space-y-4">
          <p className="text-xs text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            This site uses AI-assisted systems for analysis, prototyping, and personalization. 
            Critical recommendations are human-reviewed before implementation. Do not rely solely 
            on AI outputs for your professional decisions; consult a qualified expert when needed.
          </p>
          
          {/* ORCID iD */}
          <a id="cy-effective-orcid-url" href="https://orcid.org/0009-0002-2655-4629" target="orcid.widget" rel="me noopener noreferrer" className="inline-flex items-center justify-center text-muted-foreground hover:text-foreground transition-colors text-xs">
            <img src="https://orcid.org/sites/default/files/images/orcid_16x16.png" alt="ORCID iD icon" className="w-4 h-4 mr-1" />
            https://orcid.org/0009-0002-2655-4629
          </a>
          
          {/* Applied Work */}
          <p className="text-xs text-muted-foreground">
            Applied work: <a href="https://marketdisruptorsagency.com" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors underline">Market Disruptors AI Visibility Agency</a> — AI visibility for local service businesses.
          </p>

          {/* Contact */}
          <p className="text-xs text-muted-foreground">
            <a href="tel:+14072082594" className="hover:text-foreground transition-colors">+1-407-208-2594</a>
            {" · "}
            <a href="mailto:kristina@kristinashrider.com" className="hover:text-foreground transition-colors">kristina@kristinashrider.com</a>
            {" · "}
            <a href="https://marketdisruptorsagency.com" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">Market Disruptors AI Visibility Agency</a>
          </p>

          {/* Copyright */}
          <p className="text-xs text-muted-foreground">
            © {currentYear} Kristina Shrider | National Growth Architect, AI Strategist, Behavioral CMO & Independent Researcher
          </p>
        </div>
      </div>
    </footer>;
};
export { Footer };
